import { render, staticRenderFns } from "./WaterPage.vue?vue&type=template&id=20a747cc&scoped=true&"
import script from "./WaterPage.vue?vue&type=script&lang=js&"
export * from "./WaterPage.vue?vue&type=script&lang=js&"
import style0 from "./WaterPage.vue?vue&type=style&index=0&id=20a747cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a747cc",
  null
  
)

export default component.exports